import { Box, ButtonProps, ModBox, Spacer, Text, TextNew, TextProps } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { ButtonNew } from '../../../components/AdminButton'
import { useCallback, useEffect, useState } from 'react'
import { Dropdown } from '../../../components/Dropdown'
import { useLazyApiData, useStores } from '../../../data/store'

export const CheckerDetailsFooter = ({
  isCurrentFormValid,
  editable,
  onSubmit,
  show,
  submitActions,
  showInternalCommentsField,
  showCommentBox = true,
  commentTitle = "Checker's comments",
  internalCommentTitle = "Checker's internal comments",
  showUploadFileComp,
  merchantId,
  requestId,
}: any) => {
  const [status, setStatus] = useState('')
  const [comments, setComments] = useState('')
  const [internalComments, setInternalComments] = useState('')
  const { uploadInteractionHistoryFileAsync } = useStores((store) => ({
    uploadInteractionHistoryFileAsync: store.entityOnboarding.uploadInteractionHistoryFileAsync,
  }))
  const [lazyUploadInteractionFile, uploadInteractionFileHandler] = useLazyApiData(uploadInteractionHistoryFileAsync)
  useEffect(() => {
    if (submitActions?.find((item) => item?.description === status)?.length === 0) {
      setStatus('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitActions])

  const onDropDownChange = (selected: string) => {
    setStatus(selected)
  }

  const uploadSelectedFile = useCallback(
    (fileChosen) => lazyUploadInteractionFile(fileChosen, merchantId, requestId, fileChosen.name, fileChosen?.type),
    [],
  )

  return (
    <ModBox
      show={show}
      flexDirection="row"
      paddingHorizontal={24}
      borderTopColor={'BORDER_COLOR'}
      flexWrap={'wrap'}
      borderTopWidth={1}>
      <Box paddingVertical={16} flexDirection={'column'}>
        <Dropdown
          minHeight={32}
          minWidth={150}
          testID="selectStatus"
          title={'Select Status'}
          selectedData={onDropDownChange}
          data={submitActions}
          dataFieldToRead={'description'}
          value={status}
          label="Status"
          labelType={'label'}
          labelColor="BLACK_21"
          selectable={editable}
        />
        <UploadInteractionFile
          showUploadFileComp={showUploadFileComp}
          merchantId={merchantId}
          requestId={requestId}
          uploadSelectedFile={uploadSelectedFile}
          uploadInteractionFileHandler={uploadInteractionFileHandler}
        />
      </Box>

      <Box flexDirection={'row'} flex={1} minWidth={250} paddingVertical={16}>
        {showCommentBox && (
          <CommentBoxInput title={commentTitle} comments={comments} onCommentChange={setComments} editable={editable} />
        )}
        {showInternalCommentsField && (
          <CommentBoxInput
            title={internalCommentTitle}
            comments={internalComments}
            onCommentChange={setInternalComments}
            editable={editable}
          />
        )}
        <ModBox flex={1} show={!showInternalCommentsField} />
      </Box>
      <Box minWidth={200} paddingVertical={16}>
        <ButtonNew
          type={'primarySmall'}
          title={'Submit'}
          onPress={() =>
            onSubmit(submitActions?.find((item) => item?.description === status)?.key, comments, internalComments)
          }
          width={150}
          disabled={
            !status ||
            (!showInternalCommentsField && showCommentBox && comments?.trim().length < 2) ||
            (showInternalCommentsField && !internalComments) ||
            (!isCurrentFormValid && (status === 'APPROVE' || status === 'RISK_REFER' || status === 'SUBMIT'))
          }
          borderRadius={4}
        />
      </Box>
    </ModBox>
  )
}

const CommentBoxInput = ({ comments, onCommentChange, title, editable }) => {
  return (
    <Box flexDirection={'column'} marginHorizontal={48} flex={1} minWidth={120}>
      <TextNew fontSize={12} color={'BLACK_21'} fontFamily="jioType-medium">
        {title}
      </TextNew>
      <Box
        borderWidth={1}
        borderColor={'BORDER_COLOR'}
        borderRadius={4}
        overflow={'auto'}
        nativeID="vertical-scroll"
        paddingTop={6}
        height={72}>
        <TextInputNew
          placeholder={'Write your comments here...'}
          value={comments}
          onChangeText={onCommentChange}
          focusBorderColor={'TRANSPARENT'}
          fontWeight={'500'}
          fontSize={10}
          paddingHorizontal={8}
          paddingVertical={8}
          numberOfLines={4}
          multiline
          editable={editable}
          disabled={!editable}
          maxLength={4096}
        />
      </Box>
    </Box>
  )
}

interface UploadInteractionFile {
  showUploadFileComp?: boolean
  merchantId: string
  requestId: string
  uploadSelectedFile: any
  uploadInteractionFileHandler: any
}

const UploadInteractionFile = ({
  showUploadFileComp = false,
  merchantId,
  requestId,
  uploadSelectedFile,
  uploadInteractionFileHandler,
}: UploadInteractionFile) => {
  const onFileSelected = (e: any) => {
    const target = e.target as HTMLInputElement
    const fileChosen = (target.files as FileList)[0]
    console.log(fileChosen)
    uploadSelectedFile(fileChosen)
  }

  const onSelectFilePress = (): void => {
    const inputBoxConfigTemp = inputBoxConfig()
    const inputBox = inputBoxConfigTemp.element
    inputBox.type = inputBoxConfigTemp.type
    inputBox.accept = '.pdf,.zip,.png,.jpg,jpeg,.txt,.xls'
    inputBox.draggable = true
    inputBox.click()
    inputBox.onchange = onFileSelected
  }
  return (
    <ModBox flexDirection={'row'} show={showUploadFileComp} paddingVertical={16} alignItems={'center'}>
      <ButtonNew
        onPress={onSelectFilePress}
        isLoading={uploadInteractionFileHandler.state === 'pending'}
        disabled={uploadInteractionFileHandler.state === 'fulfilled'}
        {...styles.uploadButton}
        children={
          <Text fontSize={12} fontFamily="jioType-normal" color={'BLACK_21'}>
            Choose File
          </Text>
        }
      />
      <Spacer size={16} direction="horizontal" />
      <Text {...styles.info(uploadInteractionFileHandler.state)}>
        {uploadInteractionFileHandler.state === 'fulfilled' ? '** Document uploaded.' : 'No file choosen'}
      </Text>
    </ModBox>
  )
}
const inputBoxConfig = () => ({
  element: document.createElement('input'),
  type: 'file',
})

const styles = {
  heading: {
    color: 'BLACK_21',
    fontFamily: 'jioType-bold',
    fontSize: 16,
  } as TextProps,
  subHeading: {
    color: 'BLACK_75',
    fontFamily: 'jioType-medium',
    fontSize: 12,
  } as TextProps,
  info: (status) =>
    ({
      color: status === 'fulfilled' ? 'HAZY_GREEN' : 'BLACK_75',
      fontFamily: 'jioType-bold',
      fontSize: 12,
    } as TextProps),
  uploadButton: {
    type: 'secondarySmall',
    borderColor: 'BORDER_PRIMARY',
    title: 'Choose File',
    width: 110,
    height: 28,
    titleColor: 'BLACK_21',
    color: 'BACKGROUND',
  } as ButtonProps,
}
